var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header"},[_c('h1',{staticClass:"md-headline"},[_vm._v(_vm._s(_vm.headline))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }